module.exports = __webpack_public_path__ + "static/media/Sun Deck 1.aca5bbc5.jpg";